<template>
  <v-app>
		<v-main>
			<Main />
		</v-main>
  </v-app>
</template>

<script>
import Main from './components/Layout/Main'
import {addNewStatus} from '@/helpers/api/budgets'

export default {
  name: 'App',
  components: {
    Main
  },
	computed: {
		userAuth() {
			return this.$store.state.user.isAuthenticated
		},
		isMobile(){
			return this.$vuetify.breakpoint.mobile
		},
    preproject() {
      return this.$store.state.preprojects.preProject
    },
    preprojects() {
      return this.$store.state.preprojects.preProjects
    },
    conversation() {
      return this.$store.state.crm.conversation
    },
    conversations() {
      return this.$store.state.crm.conversations
    },
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
	},
	watch: {
		userAuth(newData, oldData) {
			if(newData && !oldData){
				this.getUserInfo()
				this.getUserGeo()
				this.$store.dispatch('general/getStates')
				this.$store.dispatch('general/getCountryCities', 44)
			}
		},
		isMobile(newData) {
			if(!newData){
				this.$store.commit('menu/setMenuSidebarStatus', true)
			}
		},
    preproject(newValue) {
      if (!this.hasWatched && newValue) {
        this.hasWatched = true;
				this.checkModalStatus()
			}
    },
    conversation(newValue) {
      if (!this.hasWatched && newValue) {
        this.hasWatched = true;
				this.checkModalStatus()
			}
    },
    preprojects(newValue) {
      if (!this.hasWatched && newValue) {
        this.hasWatched = true;
				this.checkModalStatus()
			}
    },
    conversations(newValue) {
      if (!this.hasWatched && newValue) {
        this.hasWatched = true;
				this.checkModalStatus()
			}
    }
	},
  data: () => ({
		hasWatched: false
  }),
	mounted(){
		this.$store.commit('menu/setMenuSidebarStatus', !this.$vuetify.breakpoint.mobile)
		this.$store.dispatch('general/getHolidayDays', '2025')
		this.$store.dispatch('general/getDayUf')
		if(this.$store.state.user.isAuthenticated){
			this.getUserInfo()
			this.getUserGeo()
			this.$store.dispatch('general/getStates')
			this.$store.dispatch('general/getCountryCities', 44)
			this.$store.dispatch('general/getTaxesOptions')
			this.$store.dispatch('companies/getCompanyPlanningStages')
		}
		// Listener de cambio de tamaño de pantalla
		window.addEventListener('resize', this.onResize)
		this.onResize() // Ejecutar al cargar
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize)
	},
	methods: {
		checkUrlQueries(){
			if(this.$route.query.budget_status && this.$route.query.budget_id){
				// Aceptar - Rechazar Presupuesto
				this.changeBudgetStatus(this.$route.query.budget_id, this.$route.query.budget_status == "true" ? 3:4)
			}
		},
		async changeBudgetStatus(budget_id, status){
			const resp = await addNewStatus({budget_id, status})
			if(resp.code === 200){
				const messageData = {
					message: 'Has aceptado el presupuesto, en breve la empresa comenzará a preparar los siguientes pasos de tu proyecto.',
					title: 'Presupuesto aceptado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.$store.dispatch('general/addMessage', messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', messageData)
			}
		},
		getUserGeo(){
			if ("geolocation" in navigator) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						const lat = position.coords.latitude;
						const lng = position.coords.longitude;
						this.$store.commit('general/setUserGeo', {lat, lng})
					},
					(error) => {
						if (error.code !== error.POSITION_UNAVAILABLE) {
							console.warn('Geolocalización no disponible:', error.code);
						}
					},
					{
						enableHighAccuracy: false,
						timeout: 5000,
						maximumAge: 300000
					}
				);
			}
		},
		getUserInfo(){
			this.$store.dispatch('user/getUserInfo')
			this.$store.dispatch('companies/getCompanyProjectTypes')

			//Ver para cambiar sólo a budget modal
			this.$store.dispatch('budget/getBudgetPrefixes')
			this.$store.dispatch('reports/getReportTitles')
			this.$store.dispatch('budget/getBudgetTitles')
			this.$store.dispatch('contracts/getContractTitles', {start: 0, limit: 100})
			this.$store.dispatch('budget/getBudgetConcepts')
			this.$store.dispatch('budget/getBudgetCategories')
			this.$store.dispatch('budget/getBudgetDetails')
			this.$store.dispatch('budget/getBudgetNotes')
		},
		checkModalStatus(){
			const chat_open = localStorage.getItem('chat_open')
			const budget_main_open = localStorage.getItem('budget_main_open')
			const budget_open = localStorage.getItem('budget_open')

			if(chat_open){
				this.$store.commit('preprojects/setOpenChatModal', true)
			}
			else{
				if(budget_main_open){
					this.$store.commit('preprojects/setOpenBudgetModal', true)
				}
				if(budget_open){
					const data = JSON.parse(budget_open)
					setTimeout(() => {
						this.$store.commit('general/setNewBudgetModal', data)
					}, 300)
				}
			}
		},
		onResize() {
			this.$store.commit('general/setViewerHeight', window.innerHeight)
		}
	}
};
</script>
<style>
	.v-date-picker-table td {
		padding: 0!important;
	}
	body .v-application .v-progress-linear__indeterminate,
	body .v-application .v-progress-linear__background{
		background-color: #FF120B!important; /* Cambia este color */
		border-color: #FF120B!important; /* Cambia este color */
	}
	body .v-select__selections .v-select__selection--comma{font-size: 12px;}
	body .w-100{width: 100%!important;}
	.flex-1{flex: 1;}
	.wrap-chip {
		white-space: normal !important;
		line-height: normal;
		height: auto !important;
	}
	.custom-btn-wrap{
		max-width: 100%;
		word-break: break-word;
		white-space: normal !important;
		height: auto !important;
		line-height: 1.2 !important;
		padding-top: 4px !important;
		padding-bottom: 4px !important;
	}
	.selected-row-custom-item{
		background-color: #eeeeee!important
	}
	.sticky-table-bar > div{
		position: fixed;
		background-color: white;
		width: 100%;
		padding: 12px;
		z-index: 5;
		left: 0;
		border-bottom: 1px solid #524D4D;
		margin-top: -12px;
	}
	.data-table-fixed-toolbar{
		overflow-y: scroll!important;
		flex: 1;
		display: flex;
	}
	.m2-lower {
		text-transform: lowercase;
	}
	.custom-toggle-btns .v-btn--active:before{
		opacity: 0;
	}
</style>